import { render, staticRenderFns } from "./HealthBarBlockItem.vue?vue&type=template&id=36012b36&scoped=true"
import script from "./HealthBarBlockItem.vue?vue&type=script&lang=js"
export * from "./HealthBarBlockItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36012b36",
  null
  
)

export default component.exports